import { render, staticRenderFns } from "./ChallengesMessagerieContact.vue?vue&type=template&id=314bbbe0&"
import script from "./ChallengesMessagerieContact.vue?vue&type=script&lang=js&"
export * from "./ChallengesMessagerieContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports